<template>
    <b-overlay v-if="loading" :show="loading" no-wrap>
        <template v-slot:overlay>
            <div class="text-center">
                <b-spinner
                    label="Carregando"
                    style="width: 3rem; height: 3rem"
                />
            </div>
            <div class="text-center mt-3">
                <p class="h6">
                    {{ loadingText }}
                </p>
            </div>
        </template>
    </b-overlay>
    <div v-else class="dashboard d-flex flex-column">
        <div
            v-if="includeSidebar"
            :class="`bg-open-sidebar${sidebar.open ? ' open' : ''}`"
        />
        <slot
            name="header"
            :include-sidebar="includeSidebar"
            :toggle-sidebar="toggleSidebar"
        >
            <simbar-header>
                <button
                    v-if="includeSidebar"
                    class="navbar-toggler d-block d-md-none"
                    type="button"
                    @click="toggleSidebar"
                >
                    <span class="navbar-toggler-icon" />
                </button>
            </simbar-header>
        </slot>
        <slot
            name="body"
            :include-sidebar="includeSidebar"
            :sidebar-items="sidebarItems"
            :sidebar-footer-items="sidebarFooterItems"
        >
            <dashboard-wrapper
                :include-sidebar="includeSidebar"
                :sidebar-footer-items="sidebarFooterItems"
                :sidebar-items="sidebarItems"
            >
                <slot />
            </dashboard-wrapper>
        </slot>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SimbarHeader from "../components/SimbarHeader";
import DashboardWrapper from "../components/DashboardWrapper";

export default {
    name: "BaseDashboard",
    components: {
        DashboardWrapper,
        SimbarHeader
    },
    props: {
        sidebarItems: {
            type: Array,
            default() {
                return [];
            }
        },
        sidebarFooterItems: {
            type: Array,
            default() {
                return [];
            }
        },
        loading: {
            type: Boolean,
            default: false
        },
        loadingText: {
            type: String,
            default: ""
        }
    },
    computed: {
        ...mapState("dashboard", ["sidebar"]),
        breadcrumbs() {
            const matched = this.$route.matched.map(route => ({
                text: route.meta.title,
                to: { name: route.name }
            }));
            return [
                {
                    text: "Home",
                    to: { name: "home" }
                },
                {
                    text: "...",
                    middle: true
                }
            ].concat(matched);
        },
        includeSidebar() {
            return (
                this.sidebarItems.length + this.sidebarFooterItems.length > 0
            );
        }
    },
    methods: {
        ...mapActions("dashboard", ["toggleSidebar"])
    }
};
</script>

<style lang="scss">
.dashboard {
    min-height: 100%;
    padding-top: $navbar-height;
}
</style>
